import Devices from "./Devices";

export default Devices;
